import { createReducer, on } from '@ngrx/store';
import * as ExcelActions from './excelImport.action';

export const initialState: any = getFromLocalStorage();

const _excelImporterReducer = createReducer(
  initialState,
  on(ExcelActions.createUIExcelColumnMap, (state, { dropEvent, actionType }) => {
    let returnObj = processMapOrUnMapColumns(state, dropEvent, actionType);
    return storeAndReturnState(state, returnObj);
  }),
  on(ExcelActions.initializeUIExcelColumnObj, (state, { uiTabs, excelColumns, excelUploadResponse }) => {
    storeINLocalStorage({
      uiTabsObj: uiTabs,
      excelColumnsObj: excelColumns,
      excelUploadResponse: excelUploadResponse
    });
    return {
      ...state,
      uiTabsObj: uiTabs,
      excelColumnsObj: excelColumns,
      excelUploadResponse: excelUploadResponse
    };
  }),
  on(ExcelActions.addCalcFieldInColumn, (state, { cardColumn, fieldType }) => {
    let returnObj = addCalcField(state, cardColumn, fieldType);
    return storeAndReturnState(state, returnObj);
  }),
  on(ExcelActions.deleteCalcFieldInColumn, (state, { cardColumn, index }) => {
    let returnObj = deleteCalcField(state, cardColumn, index);
    return storeAndReturnState(state, returnObj);
  }),
  on(ExcelActions.addCalcFieldValue, (state, { cardColumn, index, fieldValue }) => {
    let returnObj = addCalcFieldValue(state, cardColumn, index, fieldValue);
    return storeAndReturnState(state, returnObj);
  }),
  on(ExcelActions.addRowInTab, (state, { actionIndex, tabIndex }) => {
    let returnObj = addRowInTab(state, actionIndex, tabIndex);
    return storeAndReturnState(state, returnObj);
  }),
  on(ExcelActions.addColumnInRow, (state, { tabIndex, rowIndex, colIndex, colActionIndex }) => {
    let returnObj = addColumnInRow(state, tabIndex, rowIndex, colIndex, colActionIndex);
    return storeAndReturnState(state, returnObj);
  }),
  on(ExcelActions.removeUIExcelColumnObj, (state, {}) => {
    return removeUIExcelColumnObj();
  })
);

export function excelImportReducer(state = initialState, action) {
  return _excelImporterReducer(state, action);
}

function storeAndReturnState(state, returnObj) {
  returnObj['excelUploadResponse'] = state.excelUploadResponse;
  storeINLocalStorage(returnObj);
  return { ...state, uiTabsObj: returnObj.uiTabsObj, excelColumnsObj: returnObj.excelColumnsObj };
}

function processMapOrUnMapColumns(state, dropEvent, actionType) {
  let uiTabs = JSON.parse(JSON.stringify(state.uiTabsObj.tabs));
  let excelColumns = JSON.parse(JSON.stringify(state.excelColumnsObj.columns));
  if (actionType == 'map' && checkForSameCardColumn(dropEvent)) {
    let returnObj = mapOrUnmapDbColumn(uiTabs, excelColumns, dropEvent);
    uiTabs = returnObj.uiTabs;
    excelColumns = returnObj.excelColumns;
    if (!dropEvent.previousContainer.dropTabCardData || !dropEvent.container.dropTabCardData) {
      excelColumns = incOrDecColumnCounter(excelColumns, dropEvent.item.data, 'inc');
    }
  } else if (actionType == 'unmap' && dropEvent.previousContainer.id != dropEvent.container.id) {
    let returnObj = mapOrUnmapDbColumn(uiTabs, excelColumns, dropEvent);
    uiTabs = returnObj.uiTabs;
    excelColumns = incOrDecColumnCounter(excelColumns, dropEvent.item.data, 'dec');
  }
  return { uiTabsObj: { tabs: uiTabs }, excelColumnsObj: { columns: excelColumns } };
}

function checkForSameCardColumn(dropEvent) {
  if (dropEvent.previousContainer.dropTabCardData && dropEvent.container.dropTabCardData) {
    if (dropEvent.previousContainer.dropTabCardData.cardColumn && dropEvent.container.dropTabCardData.cardColumn) {
      if (
        dropEvent.previousContainer.dropTabCardData.cardColumn.name ==
        dropEvent.container.dropTabCardData.cardColumn.name
      ) {
        return false;
      }
    }
  }
  return true;
}

function mapOrUnmapDbColumn(uiTabs, excelColumns, dropEvent) {
  let tabIndex = -1;
  let rowIndex = -1;
  let previousFieldIndex = -1;
  let currentFieldIndex = -1;
  if (dropEvent.container.dropTabCardData) {
    tabIndex = dropEvent.container.dropTabCardData.tabIndex;
    rowIndex = dropEvent.container.dropTabCardData.rowIndex;
  }
  if (dropEvent.previousContainer.dropTabCardData) {
    tabIndex = dropEvent.previousContainer.dropTabCardData.tabIndex;
    rowIndex = dropEvent.previousContainer.dropTabCardData.rowIndex;
  }
  if (dropEvent.container.dropTabCardData) {
    currentFieldIndex = dropEvent.container.dropTabCardData.fieldIndex;
  }
  if (dropEvent.previousContainer.dropTabCardData) {
    previousFieldIndex = dropEvent.previousContainer.dropTabCardData.fieldIndex;
  }
  for (let i = 0; i < uiTabs[tabIndex].multipleRows[rowIndex].columns.length; i++) {
    if (
      dropEvent.container.dropTabCardData &&
      dropEvent.container.dropTabCardData.cardColumn &&
      uiTabs[tabIndex].multipleRows[rowIndex].columns[i].name == dropEvent.container.dropTabCardData.cardColumn.name
    ) {
      if (uiTabs[tabIndex].multipleRows[rowIndex].columns[i].isCalculator) {
        if (
          uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['valueDefinition'][currentFieldIndex]['value'] &&
          uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['valueDefinition'][currentFieldIndex]['value']['propData']
        ) {
          excelColumns = incOrDecColumnCounter(
            excelColumns,
            uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['valueDefinition'][currentFieldIndex]['value'][
              'propData'
            ],
            'dec'
          );
        }
        uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['valueDefinition'][currentFieldIndex]['value'] = {};
        uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['valueDefinition'][currentFieldIndex]['value']['propData'] =
          dropEvent.item.data;
      } else {
        if (uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['propData']) {
          excelColumns = incOrDecColumnCounter(
            excelColumns,
            uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['propData'],
            'dec'
          );
        }
        uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['propData'] = dropEvent.item.data;
      }
    }

    if (dropEvent.previousContainer.dropTabCardData && dropEvent.previousContainer.dropTabCardData.cardColumn) {
      if (
        uiTabs[tabIndex].multipleRows[rowIndex].columns[i].isCalculator &&
        uiTabs[tabIndex].multipleRows[rowIndex].columns[i].name ==
          dropEvent.previousContainer.dropTabCardData.cardColumn.name
      ) {
        delete uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['valueDefinition'][previousFieldIndex]['value'];
      } else {
        if (
          uiTabs[tabIndex].multipleRows[rowIndex].columns[i].name ==
          dropEvent.previousContainer.dropTabCardData.cardColumn.name
        ) {
          delete uiTabs[tabIndex].multipleRows[rowIndex].columns[i]['propData'];
        }
      }
    }
  }
  return { uiTabs: uiTabs, excelColumns: excelColumns };
}

function incOrDecColumnCounter(excelColumns, propData, actionType) {
  let excelColumnsIndex = -1;
  excelColumns.find((element, index) => {
    if (element.name == propData.name) {
      excelColumnsIndex = index;
      return excelColumnsIndex;
    }
  });
  if (!excelColumns[excelColumnsIndex].mapCounter) excelColumns[excelColumnsIndex].mapCounter = 0;

  if (actionType == 'inc') {
    excelColumns[excelColumnsIndex].mapCounter = excelColumns[excelColumnsIndex].mapCounter + 1;
  } else if (actionType == 'dec') {
    excelColumns[excelColumnsIndex].mapCounter = excelColumns[excelColumnsIndex].mapCounter - 1;
  }
  return excelColumns;
}

function addCalcField(state, cardColumn, fieldType) {
  let uiTabs = JSON.parse(JSON.stringify(state.uiTabsObj.tabs));
  let cardColumnIndex = -1;
  cardColumnIndex = findColumnIndex(uiTabs, cardColumn);
  if (!uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex].valueDefinition) {
    uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex].valueDefinition = [];
  }
  uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex].valueDefinition.push({
    type: fieldType
  });
  return { uiTabsObj: { tabs: uiTabs }, excelColumnsObj: state.excelColumnsObj };
}

function deleteCalcField(state, cardColumn, index) {
  let cardColumnIndex = -1;
  let uiTabs = JSON.parse(JSON.stringify(state.uiTabsObj.tabs));
  let excelColumns = JSON.parse(JSON.stringify(state.excelColumnsObj.columns));
  cardColumnIndex = findColumnIndex(uiTabs, cardColumn);
  if (
    uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex]['valueDefinition'][index][
      'value'
    ] &&
    uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex]['valueDefinition'][index][
      'value'
    ]['propData']
  ) {
    excelColumns = incOrDecColumnCounter(
      excelColumns,
      uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex]['valueDefinition'][index][
        'value'
      ]['propData'],
      'dec'
    );
  }
  uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex].valueDefinition.splice(
    index,
    1
  );
  return { uiTabsObj: { tabs: uiTabs }, excelColumnsObj: { columns: excelColumns } };
}

function addCalcFieldValue(state, cardColumn, index, fieldValue) {
  let cardColumnIndex = -1;
  let uiTabs = JSON.parse(JSON.stringify(state.uiTabsObj.tabs));
  cardColumnIndex = findColumnIndex(uiTabs, cardColumn);
  uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[cardColumnIndex].valueDefinition[
    index
  ].value = fieldValue;
  return { uiTabsObj: { tabs: uiTabs }, excelColumnsObj: state.excelColumnsObj };
}

function addRowInTab(state, actionIndex, tabIndex) {
  let uiTabs = JSON.parse(JSON.stringify(state.uiTabsObj.tabs));
  if (uiTabs[tabIndex].actions && !uiTabs[tabIndex].actions[actionIndex].multiple) {
    uiTabs[tabIndex].actions[actionIndex]['inserted'] = true;
  }
  if (uiTabs[tabIndex].actions[actionIndex].counter) {
    uiTabs[tabIndex].actions[actionIndex].label =
      uiTabs[tabIndex].actions[actionIndex].name + ' ' + uiTabs[tabIndex].actions[actionIndex].counter;
    uiTabs[tabIndex].actions[actionIndex].counter += 1;
  }
  if (uiTabs[tabIndex].multipleRows) {
    uiTabs[tabIndex].multipleRows.push(uiTabs[tabIndex].actions[actionIndex]);
  }
  if (!uiTabs[tabIndex].actions[actionIndex].counter) uiTabs[tabIndex].actions[actionIndex].counter = 1;
  return { uiTabsObj: { tabs: uiTabs }, excelColumnsObj: state.excelColumnsObj };
}

function addColumnInRow(state, tabIndex, rowIndex, colIndex, colActionIndex) {
  let uiTabs = JSON.parse(JSON.stringify(state.uiTabsObj.tabs));
  let actionColumn: any = {};
  let colActionsColumn: any = {};
  if (
    uiTabs[tabIndex].multipleRows &&
    uiTabs[tabIndex].multipleRows[rowIndex].columns &&
    uiTabs[tabIndex].multipleRows[rowIndex].columns[colIndex].columnActions
  ) {
    colActionsColumn = uiTabs[tabIndex].multipleRows[rowIndex].columns.pop();
    actionColumn = colActionsColumn.columnActions[colActionIndex];
    if (!actionColumn.counter) actionColumn.counter = 1;
    else actionColumn.counter += 1;
    if (!actionColumn.multiple) {
      colActionsColumn.columnActions[colActionIndex].inserted = true;
    }

    actionColumn.name = actionColumn.label + ' ' + actionColumn.counter;
    uiTabs[tabIndex].multipleRows[rowIndex].columns.push(actionColumn);
    uiTabs[tabIndex].multipleRows[rowIndex].columns.push(colActionsColumn);
  }
  return { uiTabsObj: { tabs: uiTabs }, excelColumnsObj: state.excelColumnsObj };
}

function findColumnIndex(uiTabs, cardColumn) {
  for (let i = 0; i < uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns.length; i++) {
    if (uiTabs[cardColumn.tabIndex].multipleRows[cardColumn.rowIndex].columns[i].name == cardColumn.name) {
      return i;
    }
  }
}

function storeINLocalStorage(obj) {
  localStorage.setItem('excelImportObj', JSON.stringify(obj));
}
function getFromLocalStorage() {
  if (localStorage.getItem('excelImportObj')) {
    return JSON.parse(localStorage.getItem('excelImportObj'));
  } else {
    return { uiTabsObj: {}, excelColumnsObj: { columns: [] }, excelUploadResponse: {} };
  }
}

function removeUIExcelColumnObj() {
  localStorage.removeItem('excelImportObj');
  return { uiTabsObj: {}, excelColumnsObj: { columns: [] }, excelUploadResponse: {} };
}
